module.exports = __webpack_public_path__ + "static/img/game-logo-saba.77fa407.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-saba.png
// module id = 7LMO
// module chunks = 0 1 2 3 4 5 6